import { Output, inject } from "@angular/core";
import { EventEmitter } from "@angular/core";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MaapLocation } from "src/app/models/location";
import { Region } from "src/app/models/region";
import { AccountManagementService } from "src/app/services/account-management.service";
import { AuthService } from "src/app/services/auth.service";
import { LocationAccessOption, LocationAccessValue, LocationFilterEvent, LocationSelectionInput } from "src/app/services/location-access.service";
import { UtilityService } from "src/app/services/utility.service";
import { environment } from 'src/environments/environment';


@Component({
    selector: "app-add-user",
    templateUrl: "./add-user.component.html",
    styleUrls: ["./add-user.component.css"],
    standalone: false
})
export class AddUserComponent implements OnInit {
  private accountManagementService = inject(AccountManagementService);
  private utilityService = inject(UtilityService);
  private router = inject(Router);
  private authService = inject(AuthService);

  private originalUser: any = null; // Add property to store original user data
  private initialSaveState: any = null; // need any type to store initial save state of the user
  private currentAccessSelection: any = {
    region: ['All'],
    campus: ['All'],
    facility: ['All'],
    locationGroup: ['All']
  };
  private readonly moduleAccessKeys = ['auditor', 'insights', 'variance', 'p2p', 'waste'];
  user: any = {};
  scope: any = {
    role: "DDPS",
    regions: [],
    campuses: [],
    facilities: ['All'],
    locationGroups:{},
    serviceGroups: [],
    accessLevel: "Facility",
    id: null,
    deactivated:false,
    enableCameraLogin:false,
    canRecieveUserUpdates: false,
    defaultRegions: [],
    defaultCampuses: [],
    defaultFacilities: [],
    auditor:false,
    insights:false,
    variance: false,
    p2p:false,
    waste: false,
    readOnly:false,
    deIdUser: false, // New property for de-identified user
  };
  isValid = false;
  versionType = environment.userAuthVersion
  enableAssayManagement = environment.enableAssayManagement;
  env = environment.environment
  roles: any = [];
  accessLevels: any = [];
  selectedLocation: any = [];
  regions: Region[] = [];
  campuses: any = {};
  facilities: any = {};
  locations: MaapLocation[] = [];
  defaultRegions: Region[] = [];
  defaultCampuses: any = {};
  defaultFacilities: any = {};
  selectedFacilityLabels: { label: string; value: string }[] = []
  locationGroupOptions = {}
  locationFilter: any = {
    region: ['All'],
    campus: ['All'],
    facility: ['All'],
    locationGroup: ['All']
  };
  @Output() saved = new EventEmitter<boolean>();
  @Output() cancelled = new EventEmitter<boolean>();
  @Output() saveMessage = new EventEmitter<any>(); // Add this new output
  i = "?#";
  showmsgdialog = false;
  msg: any = {};
  isUpdate = false;
  isCameraLoginEnabled = false;
  regionOptions: any[] = [] ;
  campusOptions: any[] = [{label:"All Campuses",value:"All"}];
  facilityOptions: any[] = [{label:"All Facilities",value:"All"}];
  ngOnInit(): void {
    this.roles = [
      { label: "DDPC", value: "DDPC" },
      { label: "DDPS", value: "DDPS" },
      { label: "DDPD", value: "DDPD" }
    ];

    if(this.versionType == 'legacy'){
    this.roles = [
      {
        label: "DDPC",
        value: "DDPC",
      },
      {
        label: "DDPS-Lead",
        value: "DDPS-Lead",
      },
      {
        label: "DDPS",
        value: "DDPS",
      }
    ];}
    else{
      this.roles = [
        {
          label: "DDPC",
          value: "DDPC",
        },
        {
          label: "DDPS",
          value: "DDPS",
        }
      ]
    }
    
    this.isCameraLoginEnabled = environment["isCameraLoginFeatureEnabled"]||false

    // if (this.getUserRole() == "DDPL") {
    this.roles = [{ label: "DDPD", value: "DDPD" }].concat(this.roles);
    // }

    this.accessLevels = [
      {
        label: "Facility",
        value: "Facility",
      },
    ];

    if(this.versionType == 'legacy'){
    this.getRegions();}
    else{
      this.loadFacilityOptions({}, null)
    }
  }

  getUserRole() {
    return this.authService.user.role;
  }

  updateAccessLevelOptions() {
    if (["DDPS", "DDPS-Lead"].includes(this.scope.role)) {
      this.scope.accessLevel = "Facility";
      this.accessLevels = [
        {
          label: "Facility",
          value: "Facility",
        },
      ];
      return;
    }

    // this.scope.accessLevel = "Region"
    this.accessLevels = [
      {
        label: "Region Admin",
        value: "Region",
      },
      {
        label: "Campus Admin",
        value: "Campus",
      },
      {
        label: "Facility Admin",
        value: "Facility",
      },
    ];
  }

  setAccessLevelOptions() {
    this.scope.campuses = [];
    this.scope.facilities = [];
    this.updateAccessLevelOptions();
    return;
  }

  roleUpdated() {
    this.scope.regions = [];
    this.scope.campuses = [];
    this.scope.facilities = ['All'];
    this.scope.locationGroups = {};
    if(this.versionType=='legacy') {
      this.setAccessLevelOptions();
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  accessLevelUpdated() {
    this.scope.regions = [];
    this.scope.campuses = [];
    this.scope.facilities = [];
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  setAccessLevel(e: any) {
    this.scope.regions = [];
    this.scope.campuses = [];
    this.scope.facilities = [];
    this.scope.accessLevel = e.value;
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  getRegions() {
    this.accountManagementService.getRegions().subscribe((res) => {
      this.regions = res;
      this.regionOptions = [{ label: "ALL REGIONS", value: "All" }].concat(
        res
      );
    });
    this.regions = this.utilityService.removeDuplicates(
      this.locations.map((item) => {
        return { label: item.region, value: item.region, key: item.region };
      })
    );
    this.regionOptions = this.utilityService.removeDuplicates(
      this.locations.map((item) => {
        return { label: item.region, value: item.region, key: item.region };
      })
    );
    this.loadDefaultCampusOptions()
  }

  loadCampusOptions(region: any, event: any) {
    if (!event) {
      delete this.campuses[region.label];
      return;
    }
    this.accountManagementService
      .getCampusesFromRegionId(region.id)
      .subscribe((res) => {
        this.campuses[region.label] = res;
      });
  }

  toggleAllRegions(e: any) {
    if(e.checked){
      this.regions.forEach((region) => {
        this.scope.regions.push(region.id)
        this.loadCampusOptions(region, true)
      });
      this.scope.regions = [...this.scope.regions]
    }
    else{
      this.scope.regions = [];
      this.campuses = {}
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  loadFacilityOptions(campus: any, event: any) {
    if (!event && this.versionType == 'legacy') {
      delete this.facilities[campus.label];
      return;
    }
    if (!Object.prototype.hasOwnProperty.call(campus, 'id')) {
      campus.id = null
    }
    this.accountManagementService
      .getFacilitiesFromCampusId([campus.id], [])
      .subscribe((res) => {
        if (this.versionType == 'legacy'){
        this.facilities[campus.label] = res;
        }
        else{
          this.facilityOptions = this.facilityOptions.concat(res.map((fac: any) => { return {label:fac.label, value:fac.id}}))
        }
      });
  }

  
  toggleAllCampus(e: any) {
    if(e.checked){
      Object.keys(this.campuses).forEach((region) =>{
        this.campuses[region].forEach((campus: any) => {
          this.scope.campuses.push(campus.id)
          this.loadFacilityOptions(campus, true)
        })
      })
      this.scope.campuses = [...this.scope.campuses]
    }
    else{
      this.scope.campuses = [];
      this.scope.facilities = [];
      this.facilities = {};
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  toggleAllFacility(e: any) {
    if(e.checked){
      Object.keys(this.facilities).forEach((campus) =>{
        this.facilities[campus].forEach((facility: any) => {
          this.scope.facilities.push(facility.id)
        })
      })
      this.scope.facilities = [...this.scope.facilities]
    }
    else{
      this.scope.facilities = [];
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }


  deleteItem(array: any[], item: any) {
    const index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  resetSelections(selections: any[], key: string) {
    selections = selections.filter((item) => item.key.startsWith(key));
  }

  resetAccessPermissions() {
    this.scope.regions = [];
    this.scope.campuses = [];
    this.scope.facilities = [];
    this.scope.locationGroups = [];
    this.facilities = [];
    this.campuses = [];
    this.scope.defaultRegions = "undefined";
    this.scope.defaultCampuses = "undefined";
    this.scope.defaultFacilities = "undefined";
    this.locationFilter = {
      region: [],
      campus: [],
      facility: [],
      locationGroup: []
    };
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  saveUser() {
    const data: any = {};
    data["id"] = this.scope.id;
    data["username"] = this.scope.username;
    data["fullname"] = this.scope.fullname;
    data["email"] = this.scope.email;
    if (
      ![null, "", undefined].includes(this.scope.pincode)
    ) {
      data["pincode"] = this.scope.pincode;
    }
    
    data["canRecieveUserUpdates"] = this.scope.canRecieveUserUpdates;
    data["deactivated"] = this.scope.deactivated;
    data["enableCameraLogin"] = this.scope.enableCameraLogin;
    data["deIdUser"] = this.scope.deIdUser;
    data["authorizations"] = {};
    data["authorizations"]["role"] = this.scope.role;
    data["authorizations"]["serviceGroups"] = this.scope.serviceGroups;
    data["authorizations"]["level"] = this.scope.accessLevel;
    data["authorizations"]["dataAccessRights"] = {};
    data["authorizations"]["dataAccessRights"]["regions"] = this.scope.regions;
    data["authorizations"]["dataAccessRights"]["campuses"] = this.scope.campuses;
    data["authorizations"]["dataAccessRights"]["facilities"] = this.scope.facilities;
    data["authorizations"]["dataAccessRights"]["locationGroups"] = this.scope.locationGroups;
    data["authorizations"]["dataAccessRights"]["readOnly"] = this.scope.readOnly
    data["authorizations"]["dataAccessRights"]["modules"] = this.buildModuleState();

    data["defaultRegions"] = this.scope.defaultRegions;
    data["defaultCampuses"] = this.scope.defaultCampuses;
    data["defaultFacilities"] = this.scope.defaultFacilities;
    data["defaultLocationGroups"] = this.scope.defaultLocationGroups;

    this.accountManagementService.saveUser(data).subscribe(
      () => {
        // Emit success message to parent
        this.saveMessage.emit({
          title: "Success",
          details: this.scope.id == null ? 
            "User Saved Successfully" : 
            "User Updated Successfully"
        });
        this.saved.emit(true);
      },
      (err) => {
        // Emit error message to parent
        this.saveMessage.emit({
          title: "Error",
          details: err.error.message
        });
      }
    );
  }

  closeErrorDialog() {
    if (this.msg.title == "Success") {
      this.router.navigate(["/accounts"]);
    }
  }

  loadUser(user: any) {
    this.originalUser = JSON.parse(JSON.stringify(user));
    this.isValid = false;
    this.scope = {};
    
    // Set basic user info including name and email
    this.scope.id = user._id || null;
    this.scope.fullname = user.fullname || '';
    this.scope.email = user.email || '';
    this.scope.username = user.username || user.email || '';
    this.scope.role = user.authorizations.role || null;
    this.scope.readOnly = user.authorizations.dataAccessRights.readOnly || false;
    const modules = this.getUserModules(user);
    
    // Ensure module access is properly initialized from the modules object
    this.scope.auditor = modules.auditor;
    this.scope.insights = modules.insights;
    this.scope.variance = modules.variance;
    this.scope.p2p = modules.p2p;
    this.scope.waste = modules.waste;

    // Initialize filter with user's access rights
    this.locationFilter = {
      region: user.authorizations.dataAccessRights.regions?.length ? 
        user.authorizations.dataAccessRights.regions : ['All'],
      campus: user.authorizations.dataAccessRights.campuses?.length ? 
        user.authorizations.dataAccessRights.campuses : ['All'],
      facility: user.authorizations.dataAccessRights.facilities?.length ? 
        user.authorizations.dataAccessRights.facilities : ['All'],
      locationGroup: Array.isArray(user.authorizations.dataAccessRights.locationGroups) ?
        (user.authorizations.dataAccessRights.locationGroups.length ? 
          user.authorizations.dataAccessRights.locationGroups : ['All']) :
        ['All']
    };
  
    // Set the scope access rights to match the filter
    this.scope.regions = this.locationFilter.region;
    this.scope.campuses = this.locationFilter.campus;
    this.scope.facilities = this.locationFilter.facility;
    this.scope.locationGroups = this.locationFilter.locationGroup;
    this.setCurrentAccessSelection(this.locationFilter);
    
    // Set module access
    this.scope.auditor = modules.auditor;
    this.scope.insights = modules.insights;
    this.scope.variance = modules.variance;
    this.scope.p2p = modules.p2p;
    this.scope.waste = modules.waste;

    // Additional user settings
    this.scope.deactivated = user.deactivated || false;
    this.scope.deIdUser = user.deIdUser || false;
    this.scope.enableCameraLogin = user.enableCameraLogin || false;
    this.scope.canRecieveUserUpdates = user.canRecieveUserUpdates || false;
    this.scope.accessLevel = user.authorizations.level || 'Facility';
    this.scope.serviceGroups = user.authorizations.serviceGroups || [];

    // Validate form after loading user data
    this.captureInitialSaveState();
    this.validateForm(); // This will now check both validity and changes
  }

  hasChanges(): boolean {
    if (!this.initialSaveState) return false;
    return !this.statesEqual(this.buildSaveState(), this.initialSaveState);
  }

  canSave(): boolean {
    return this.hasChanges();
  }

  validateForm() {
    this.isValid = this.canSave();
  }

  cancelEdit() {
    this.cancelled.emit(true);
    this.router.navigate(["/accounts"]);
  }

  validateNum(event: any) {
    event.preventDefault();

    const currVal = this.scope.pincode ? this.scope.pincode : "";
    // Checks if the key pressed is a number and the right length
    if (!isNaN(event.key) && currVal.length < 6) {
      this.scope.pincode = currVal + event.key;
    }
    // Backspace functionality
    else if (event.keyCode == 8 && currVal > 0) {
      this.scope.pincode = this.scope.pincode.value.slice(0, -1);
    }
  }

  onLocationSelectionChanged(event: LocationFilterEvent) {
    if (event.changeValue) {
      this.setCurrentAccessSelection(event);
      // Update scope with selected locations
      this.updateScopeLocations(event);
      this.validateForm(); // Recheck validity and changes after location updates
    }
  }

  onLocationSelectInitialized(event: LocationFilterEvent) {
    this.setCurrentAccessSelection(event);
    // Set initial location values
    this.updateScopeLocations(event);
    this.validateForm();
  }

  private updateScopeLocations(selections: LocationFilterEvent): void {
    const selectedRegions = this.normalizeSelectionValues(selections.region);
    const selectedCampuses = this.normalizeSelectionValues(selections.campus);
    const selectedFacilities = this.normalizeSelectionValues(selections.facility);
    const selectedLocationGroups = this.normalizeSelectionValues(selections.locationGroup);

    // Handle regions and campuses as before
    if (this.hasAllSelection(selectedRegions)) {
      this.accountManagementService.getRegions().subscribe(regions => {
        this.scope.regions = regions.map((r: LocationAccessOption) => r.value);
      });
    } else {
      this.scope.regions = selectedRegions;
    }

    if (this.hasAllSelection(selectedCampuses)) {
      this.accountManagementService.getCampusesFromRegionId(this.scope.regions).subscribe(campuses => {
        this.scope.campuses = campuses.map((c: LocationAccessOption) => c.value);
      });
    } else {
      this.scope.campuses = selectedCampuses;
    }

    if (this.hasAllSelection(selectedFacilities)) {
      this.scope.facilities = ['All'];
    } else {
      this.scope.facilities = selectedFacilities;
    }

    if (this.hasAllSelection(selectedLocationGroups)) {
      this.scope.locationGroups = ['All'];
    } else {
      this.scope.locationGroups = selectedLocationGroups;
    }
  }

  private normalizeSelectionValues(values: LocationSelectionInput): LocationAccessValue[] {
    if (!Array.isArray(values)) {
      return [this.getSelectionValue(values)].filter((value) => value !== undefined && value !== null);
    }

    return values
      .map((value) => this.getSelectionValue(value))
      .filter((value) => value !== undefined && value !== null);
  }

  private getSelectionValue(value: LocationAccessValue | LocationAccessOption | null | undefined): LocationAccessValue | undefined {
    if (value && typeof value === 'object' && 'value' in value) {
      return value.value;
    }

    if (typeof value === 'string') {
      return value;
    }

    return undefined;
  }

  private hasAllSelection(values: LocationAccessValue[]): boolean {
    return values.some((value) => value === 'All');
  }

  loadDefaultCampusOptions(){ 
    const region = this.scope.defaultRegions;
    this.accountManagementService.getDefaultCampusesFromRegionId(region).subscribe((
      res: any) => {
        this.defaultCampuses[region.label] = [{ label: "All CAMPUSES", value: "All" }].concat(res);
      }
    );
    this.loadDefaultFacilityOptions();
  }

  loadDefaultFacilityOptions(){
    const campus = this.scope.defaultCampuses; 
    this.accountManagementService.getDefaultFacilitiesFromCampusId(campus).subscribe((
      res: any) => {
        this.defaultFacilities[campus.label] = [{ label: "ALL FACILITY", value: "All" }].concat(res);
      }
    );
  }

  onRegionChanged(){
    this.scope.defaultCampuses = "undefined";
    this.scope.defaultFacilities = "undefined";
    this.loadDefaultCampusOptions();
    this.facilityOptions = [{label:"ALL FACILITY",value:"All"}]
  }

  onCampuseChanged(){
    this.scope.defaultFacilities = "undefined";
    this.loadDefaultFacilityOptions();
  }

  onFacilitieChanged(event: any) {
    const opp = this.facilityOptions.find(fac => fac.value==event.itemValue)
    if (event.value.length == 0){
      event.value.push('All');
      }
    else if (event.value[event.value.length - 1] == 'All'){
        this.scope.facilities = ['All']
      }
    else{
        if (event.value.includes('All'))
        this.scope.facilities.splice(this.scope.facilities.indexOf('All'), 1)
      }

    if(opp){
      if(event.itemValue == 'All'){
        this.selectedFacilityLabels = []
        this.locationGroupOptions = {}
      }
      else if (!this.selectedFacilityLabels.find(fac => fac.value==event.itemValue)){
        this.selectedFacilityLabels.push(opp)
        this.getLocationGroupOptions(opp.label)
      }
      else{
        const idx = this.selectedFacilityLabels.findIndex(fac => fac.value==event.itemValue)
        this.selectedFacilityLabels.splice(idx, 1)
        delete (this.locationGroupOptions as any)[event.itemValue]
      }
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  getLocationGroupOptions(facilityID: any){
    this.scope.locationGroups[facilityID] = ['All']
    this.accountManagementService.getLocationGroupsByFacility([],[],facilityID).subscribe((res) => {
      (this.locationGroupOptions as any)[facilityID] = [{label:'All Locations', value:'All'}].concat(res['locs'].map((loc: any) => {
        return {label:loc['group'], value:loc['group']}
      }
      ))
    })
  }

  onLocationGroupChange(event: any, id: any){
    if(event.itemValue == 'All'){
      this.scope.locationGroups[id] = ['All']
    }
    else{
      const allIdx = event.value.indexOf('All')
      if(allIdx != -1){
        event.value.splice(allIdx, 1)
      }
      this.scope.locationGroups[id] = event.value
    }
    this.setCurrentAccessSelectionFromScope();
    this.validateForm();
  }

  onFieldChange() {
    this.validateForm();
  }

  onModuleChange() {
    this.validateForm();
  }

  onSettingChange() {
    this.validateForm();
  }

  // Add new method to handle module toggling
  toggleModule(moduleName: string) {
    if (this.scope && moduleName in this.scope) {
      this.scope[moduleName] = !this.scope[moduleName];
      this.validateForm();
    }
  }
  private captureInitialSaveState() {
    this.initialSaveState = this.buildSaveState();
  }

  private buildSaveState() {
    return {
      user: {
        fullname: this.normalizeComparableValue(this.scope.fullname),
        email: this.normalizeComparableValue(this.scope.email),
        username: this.normalizeComparableValue(this.scope.username),
        pincode: this.normalizeComparableValue(this.scope.pincode),
        deactivated: Boolean(this.scope.deactivated),
        enableCameraLogin: Boolean(this.scope.enableCameraLogin),
        canRecieveUserUpdates: Boolean(this.scope.canRecieveUserUpdates),
        deIdUser: Boolean(this.scope.deIdUser),
        readOnly: Boolean(this.scope.readOnly)
      },
      role: this.normalizeComparableValue(this.scope.role),
      accessLevel: this.normalizeComparableValue(this.scope.accessLevel),
      serviceGroups: this.normalizeComparableValue(this.scope.serviceGroups),
      defaultAccess: {
        regions: this.normalizeComparableValue(this.scope.defaultRegions),
        campuses: this.normalizeComparableValue(this.scope.defaultCampuses),
        facilities: this.normalizeComparableValue(this.scope.defaultFacilities),
        locationGroups: this.normalizeComparableValue(this.scope.defaultLocationGroups)
      },
      access: this.buildAccessState(),
      modules: this.buildModuleState()
    };
  }

  private buildAccessState() {
    return {
      regions: this.normalizeComparableValue(this.currentAccessSelection.region),
      campuses: this.normalizeComparableValue(this.currentAccessSelection.campus),
      facilities: this.normalizeComparableValue(this.currentAccessSelection.facility),
      locationGroups: this.normalizeComparableValue(this.currentAccessSelection.locationGroup)
    };
  }

  private buildModuleState() {
    return this.moduleAccessKeys.reduce((modules: any, moduleKey: string) => {
      modules[moduleKey] = Boolean(this.scope[moduleKey]);
      return modules;
    }, {});
  }

  private getUserModules(user: any) {
    const modules = user?.authorizations?.modules ||
      user?.authorizations?.dataAccessRights?.modules ||
      user?.modules ||
      {};

    return this.moduleAccessKeys.reduce((moduleState: any, moduleKey: string) => {
      moduleState[moduleKey] = Boolean(modules[moduleKey]);
      return moduleState;
    }, {});
  }

  private setCurrentAccessSelection(selections: any) {
    this.currentAccessSelection = {
      region: this.toSelectionArray(selections?.region),
      campus: this.toSelectionArray(selections?.campus),
      facility: this.toSelectionArray(selections?.facility),
      locationGroup: this.toSelectionArray(selections?.locationGroup)
    };
  }

  private setCurrentAccessSelectionFromScope() {
    this.currentAccessSelection = {
      region: this.toSelectionArray(this.scope.regions),
      campus: this.toSelectionArray(this.scope.campuses),
      facility: this.toSelectionArray(this.scope.facilities),
      locationGroup: this.toSelectionArray(this.scope.locationGroups)
    };
  }

  private toSelectionArray(value: any): any[] {
    if (Array.isArray(value)) return [...value];
    if ([null, undefined, ''].includes(value)) return [];
    return [value];
  }

  private normalizeComparableValue(value: any): any {
    if (Array.isArray(value)) {
      return value
        .map((item) => this.normalizeComparableValue(item))
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    }

    if (value && typeof value === 'object') {
      const displayValue = this.getDisplayComparableValue(value);
      if (displayValue !== undefined) {
        return this.normalizeComparableValue(displayValue);
      }

      return Object.keys(value).sort().reduce((normalized: any, key: string) => {
        normalized[key] = this.normalizeComparableValue(value[key]);
        return normalized;
      }, {});
    }

    return value ?? null;
  }

  private getDisplayComparableValue(value: any): any {
    if (value.name !== undefined) return value.name;
    if (value.group !== undefined) return value.group;
    if (value.value !== undefined) return value.value;
    if (value._id !== undefined) return value._id;
    if (value.id !== undefined) return value.id;
    return undefined;
  }

  private statesEqual(first: any, second: any): boolean {
    return JSON.stringify(first) === JSON.stringify(second);
  }
}
